var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "rb-holiday-wrapper",
      class: "rb-holiday-wrapper--" + _vm.backgroundColor,
    },
    [
      _vm._t("title"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "rb-holiday-wrapper__banners",
          class: _vm.dynamicVariants,
        },
        [
          _c(
            "rb-smart-container",
            {
              attrs: {
                "space-between-slides": _vm.getSpaceBetweenSlides,
                "slides-per-view-desktop": 4,
                "slides-per-view-mobile": 2,
                "with-navigation-arrows": false,
                "columns-of-next-slide": _vm.columnsOfNextSlide,
                pagination: _vm.isPaginationVisible,
                "swiper-theme": _vm.swiperNavigationColor,
                "column-gap": 2,
              },
            },
            [_vm._t("banners")],
            2
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }